import React, { useState, useEffect, useRef, useCallback } from "react";
import {Col , ProgressBar , Form , Button} from "react-bootstrap";
import { base, s3base } from "api.js";
import NoMicrophone from "views/NoMicrophone.jsx";
import Sound from 'react-sound';
import ReusableRecorder from "components/Recorder/ReusableRecorder.jsx";
import "components/custom.css";
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns.jsx";
import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";
import stopImage from "assets/images/stop recording.png";
import grayImage from "assets/images/gray circle.png";
import MicWaveform from 'components/Question/Speaking/MicWaveform';
import { isIOSDevice } from 'util/deviceDetection';
import useBeep from 'components/BeepSound';
import IOSAudioPlayer from "components/Question/Speaking/New/IOSAudioPlayer.jsx";
import Beep from "Beep.js";

// import getBlobDuration from 'get-blob-duration';
// import { startCountdown } from "util/helper";
// import SpeechRecognition from 'react-speech-recognition';
// import Dictaphone from "components/Question/Speaking/Dictaphone.jsx";

const RepeatSentence = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(3);
  const [secondCount2, setSecondCount2] = useState(3);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [intervalId2, setIntervalId2] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [soundStatus, setSoundStatus] = useState(true);
  const [soundPer, setSoundPer] = useState(0);
  const [volume, setVolume] = useState(100);
  const [trans, setTransState] = useState('');
  const [correctFlag, setCorrectFlag] = useState(true);
  const [beepStatus, setBeepStatus] = useState(false);
  const [file, setFile] = useState('');
  const [duration, setDuration] = useState(0);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [secondCount2Bckup, setSecondCount2Bckup] = useState(0);
  const [questionAudio, setQuestionAudio] = useState(null);
  const [defaultSelectedVoice, setDefaultSelectedVoice] = useState(null);
  const [remainingTime, setRemainingTime] = useState("00:00");
  const [recordingTimeLeft, setRecordingTimeLeft] = useState(10);
  const [recordingProgress, setRecordingProgress] = useState(0);
  // const [recordingStartTime, setRecordingStartTime] = useState(0);

  const reusableRecorderRef = useRef(null);
  const recordingIntervalRef = useRef(null);
  const beepPlayedRef = useRef(false);
  const submittedRef = useRef(false);
  const { playBeep } = useBeep({ frequency: 800, duration: 300, volume: 0.3 });
  const handleRecordingCompleteRef = useRef(null);
  const LIMIT = 10;

  // Component mount effect
  useEffect(() => {
    if (!props.answer) {
      let question_audio = null;
      let defaultSelectedVoice = null;
      if ('question_audios' in props.data && props.data.question_audios.length > 0) {
        let x = parseInt(Math.random() * 6);

        const { question_audios } = props.data;
        question_audio = `${s3base}/${question_audios[x].value}`;
        defaultSelectedVoice = question_audios[x].label;
      } else {
        const { media_link } = props.data;
        question_audio = `${s3base}${media_link}`;
      }

      const interval = setInterval(timer, 1000);
      setIntervalId(interval);
      setQuestionAudio(question_audio);
      setDefaultSelectedVoice(defaultSelectedVoice);
    }

    if (!props.resultMode) {
      navigator.mediaDevices.getUserMedia({ audio: true }).then(() => {
        setIsBlocked(false);
      }).catch(() => {
        setIsBlocked(true);
      });
    } else {
      setIsBlocked(false);
    }

    return () => {
      clearInterval(intervalId);
      if (recordingIntervalRef.current) {
        clearInterval(recordingIntervalRef.current);
      }
    };
  }, []);

  // Handle props changes
  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalId);
        clearInterval(intervalId2);
        clearInterval(recordId);
        if (recordingIntervalRef.current) {
          clearInterval(recordingIntervalRef.current);
        }
        let question_audio = null;
        let defaultSelectedVoice = null;
        if ('question_audios' in props.data && props.data.question_audios.length > 0) {
          let x = parseInt(Math.random() * 6);

          const { question_audios } = props.data;
          question_audio = `${s3base}/${question_audios[x].value}`;
          defaultSelectedVoice = question_audios[x].label;
        } else {
          const { media_link } = props.data;
          question_audio = `${s3base}${media_link}`;
        }

        setCorrectFlag(true);
        setRecordCount(0);
        setSoundPer(0);
        setIsRecording(false);
        setSecondCount(3);
        setSecondCount2(3);
        setQuestionId(props.data.id);
        setBlobURL('');
        setTransState('');
        setDuration(0);
        setReset(true);
        setSoundStatus(true);
        setIntervalId2(0);
        setQuestionAudio(question_audio);
        setDefaultSelectedVoice(defaultSelectedVoice);
        setRecordingTimeLeft(10);
        setRecordingProgress(0);
        beepPlayedRef.current = false;
        submittedRef.current = false;
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
        }
      }
    }
  }, [props.data, props.restart]);

  const startRecordingNow = useCallback(() => {
    if (isBlocked) return;

    if (reusableRecorderRef.current) {
      reusableRecorderRef.current.startRecording();
    }
  }, [isBlocked]);

  const startRecording = () => {
    if (isBlocked) {
      return;
    }

    if (!beepPlayedRef.current) {
      beepPlayedRef.current = true;
      // Start recording immediately when beep begins so no audio is missed
      startRecordingNow();
      setBeepStatus(true);
    }
  };

  const handleBeepFinishedPlaying = () => {
    // Recording already started when beep began — just clear beep status
    setBeepStatus(false);
  };

  const handlePlayBeep = useCallback(() => {
    playBeep({
    onStart: () => {
      setBeepStatus(true);
      // Start recording immediately when beep begins so no audio is missed
      startRecordingNow();
    },
    onComplete: () => {
      setBeepStatus(false);
    },
    onError: (error) => {
      console.error('Beep failed:', error);
      setBeepStatus(false);
    }
    });
  }, [playBeep, startRecordingNow]);

  useEffect(() => {
    if (isIOSDevice() && beepStatus) {
      handlePlayBeep();
    }
  }, [beepStatus, playBeep, isIOSDevice]);

  const stop = () => {
    if (reusableRecorderRef.current && isRecording) {
      reusableRecorderRef.current.stopRecording();
    }
  };

  const stopTest = async () => {
    if (submittedRef.current) return;
    submittedRef.current = true;
    
    if (reusableRecorderRef.current && isRecording) {
      reusableRecorderRef.current.stopRecording();
    } else {
      props.nextQuestion({ 'data': file, 'audio_text': trans, duration: duration });
    }
  };

  const updateCorrect = () => {
    props.submit({ 'data': '', duration: duration });
    setCorrectFlag(false);
  };

  const setTrans = (a) => {
    if (trans !== a) {
      setTransState(a);
    }
  };

  const timer = () => {
    setSecondCount((prevCount) => {
      if (prevCount === 0) {
        clearInterval(intervalId);
        return 0;
      }
      return prevCount - 1;
    });
  };

  const timer1 = () => {
    setSecondCount2((prevCount) => {
      if (prevCount === 0) {
        clearInterval(intervalId2);
        startRecording();
        setSoundStatus(false);
        return 0;
      } else {
        if (secondCount2Bckup === 0) {
          setSecondCount2Bckup(prevCount);
        }
        return prevCount - 1;
      }
    });
  };

  const skip = () => {
    clearInterval(intervalId);
    setSecondCount(0);
  };

  const handleSongFinishedPlaying = () => {
    if (isBlocked) {
      // console.log('Permission Denied');
    } else {
      const interval = setInterval(timer1, 1000);
      setIntervalId2(interval);
      setSecondCount2(3);
      setSecondCount2Bckup(3);
      setSoundStatus(false);
      props.soundChecked();
    }
  };

  const formatTime = (ms) => {
    if (!ms || ms < 0) return "00:00";
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  const handleSongPlaying = (obj) => {
    const remainingMs = obj.duration - obj.position;
    setSoundPer(obj.position * 100 / obj.duration);
    setRemainingTime(formatTime(remainingMs));
  };

  const loadingSound = (obj) => {
    if (obj.duration !== 0) {
      setSoundStatus(true);
    }
  };

  const changeRange = (e) => {
    setVolume(e.target.value);
  };

  const changePlaybackSpeed = (speed) => {
    setSoundKey((prevKey) => prevKey + 1);
    setPlaybackSpeed(speed);
    setSecondCount2(secondCount2Bckup);
  };

  const changeAudio = (selected) => {
    clearInterval(intervalId2);
    setIntervalId2(0);

    const { question_audios } = props.data;
    const selected_audio = question_audios.filter((audio, i) => {
      return audio.label === selected.label;
    });

    setQuestionAudio(`${s3base}/${selected_audio[0].value}`);
  };

  useEffect(() => {
    if (reset) {
      const interval = setInterval(timer, 1000);
      setIntervalId(interval);
      setReset(false);
      setRecordingTimeLeft(10);
      setRecordingProgress(0);
      beepPlayedRef.current = false;
    }
  }, [reset]);

  useEffect(() => {
    if (props.testMode && props.stopRecording) {
      stopTest();
    }
  }, [props.stopRecording]);

  useEffect(() => {
    if (props.restart) {
      props.restartQue();
    }
  }, [props.restart]);

  useEffect(() => {
    if (props.data && correctFlag) {
      updateCorrect();
    }
  }, [props.data, correctFlag]);

  let questionText = "";
  if (props.data) {
    questionText = props.data.question;
  }

  if (isBlocked) {
    return (<NoMicrophone />);
  }

  const handleRecordingComplete = (recordingData) => {
    if (recordingIntervalRef.current) {
      clearInterval(recordingIntervalRef.current);
      recordingIntervalRef.current = null;
    }

    setBlobURL(recordingData.url);
    setFile(recordingData.file);
    setDuration(recordingData.duration);
    setIsRecording(false);
    setRecordCount(100);
    setRecordingProgress(100);
    setTransState(recordingData.transcript);
    
    if (isIOSDevice() && !submittedRef.current) return;

    const data_to_send = {
      data: recordingData.file,
      audio_text: recordingData.transcript,
      duration: recordingData.duration
    };

    if (props.testMode) {
      props.nextQuestion(data_to_send);
    } else {
      props.submit(data_to_send, true);
      props.showResult();
    }
  };

  const handleRecordingStart = () => {
    setIsRecording(true);
    setBlobURL('');
    setRecordCount(0); // Reset count
    setRecordingTimeLeft(10);
    
    // ADDED: Start timer that increments recordCount every second
    if (recordingIntervalRef.current) {
      clearInterval(recordingIntervalRef.current);
    }
    
    recordingIntervalRef.current = setInterval(() => {
      setRecordCount((prevCount) => {
        const newCount = prevCount + 1;
        
        // Update time left
        const timeLeft = Math.max(10 - newCount, 0);
        setRecordingTimeLeft(timeLeft);
        
        // Stop recording when we reach 10 seconds
        if (newCount >= LIMIT + 1) {
          clearInterval(recordingIntervalRef.current);
          recordingIntervalRef.current = null;
          // Force stop the recording
          if (reusableRecorderRef.current) {
            reusableRecorderRef.current.stopRecording();
          }
          return 10; // Cap at 10
        }
        
        return newCount;
      });
    }, 1000); // Update every second
  };

  const handleRecordingStop = () => {
    if (recordingIntervalRef.current) {
      clearInterval(recordingIntervalRef.current);
      recordingIntervalRef.current = null;
    }
    setIsRecording(false);
  };

   handleRecordingCompleteRef.current = handleRecordingComplete;
  
    const stableHandleRecordingComplete = useCallback((data) => {
      handleRecordingCompleteRef.current(data);
    }, []);
  
  return (
    <>
      <ReusableRecorder
        ref={reusableRecorderRef}
        onRecordingComplete={stableHandleRecordingComplete}
        onRecordingStart={handleRecordingStart}
        onRecordingStop={handleRecordingStop}
        maxDuration={10000}
        enableSpeechRecognition={true}
        fileName="noname3.mp3"
      />
      
      <Col xs={12}>
        <h4 className="infoText"></h4>
      </Col>
      <Col xs={12}>
        <div className="col-lg-12 p-0 text-center">
          {!props.resultMode && <div>
            <div className="currentStatus d-flex justify-content-center align-items-center p-0 audio-player-section">
              <div className="w-100 text-white p-4" >
                <div className="d-flex justify-content-end w-100 align-items-center min-height-player-text">
                {(secondCount === 0 && blobURL === '' && !isRecording) &&
                    <p className="mb-0 fs-10">{remainingTime}</p>
                  }
                </div>
                <div className="d-flex justify-content-center align-content-center w-100 gap-3" >
                  <i className="fa fa-play" aria-hidden="true"></i>
                  <div className="flex-grow-1">
                    <ProgressBar style={{ backgroundColor: "#e9ecef", height: "15px" }}
                      barstyle={{ backgroundColor: "#4493e0" }} now={(soundPer)} />
                  </div>
                </div>
                  <div className="d-flex justify-content-start w-100 align-items-center min-height-player-text">
                    {soundPer === 100 ? (
                      <p className="mb-0 fs-10 mx-4">Completed</p>
                    ) : soundStatus === true &&
                      secondCount !== 0 &&
                      !isRecording ? (
                      <p className="mb-0 fs-10 mx-4">
                        The clip will begin in {secondCount} seconds
                      </p>
                    ) : (
                      <p className="mb-0 fs-10 mx-4 invisible"></p>
                    )}
                  </div>
                {!props.testMode && (
                  <div className="d-flex justify-content-between">
                    <div className='stop-btn'>
                      {
                        secondCount !== 0 &&
                        blobURL === '' &&
                        !isRecording &&
                        <Button variant="success" onClick={skip} size="sm">Skip</Button>
                      }
                    </div>

                    <div className="stop-btn clearfix">
                      <div className="select-voice pull-left">
                        {defaultSelectedVoice !== null &&
                          <SelectVoiceDropDown
                            voices={props.voices}
                            selected={defaultSelectedVoice}
                            changeAudio={changeAudio}
                          />
                        }
                      </div>
                      <div className="select-speed pull-right">
                        <PlaybackSpeedBtns
                          changePlaybackSpeed={changePlaybackSpeed}
                          playbackSpeed={playbackSpeed}
                        />
                      </div>
                    </div>

                  </div>
                )}

                <br></br>
                <div className="w-100 d-flex justify-content-center align-items-center" >
                  <div className="d-flex justify-content-center gap-3  align-items-center w-50" >
                    <i className="fa fa-volume-up" aria-hidden="true"></i>
                    <Form.Control placeholder="Volume" type="range" min="0" defaultValue={volume} step="1" onInput={(e) => changeRange(e)} max="100" />
                  </div>
                </div>
              </div>

            </div>
            <div className="audio-box border-0 mock-resource-text">
              <p className="px-5 mx-2 text-secondary pb-0 mb-0"> {blobURL === '' && isRecording ? "Recording" : ""} </p>
              <hr></hr>
              {!props.testMode && isRecording && (
                <div className='stop-btn'>
                  <Button variant="success" onClick={stop} size="sm">Stop</Button>
                </div>
              )}
              <hr></hr>
              <div
                className="d-flex justify-content-start align-items-center gap-3"
                style={{ minHeight: "60px" }}
              >
                {isRecording ? (
                  <img
                    src={stopImage}
                    alt="Stop Recording"
                    style={{
                      height: "65px",
                      width: "65px",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                ) : (
                  <div className="d-flex justify-content-center align-items-center">
                    <img
                      src={grayImage}
                      alt="Not Recording"
                      style={{
                        height: "65px",
                        width: "65px",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                    {secondCount2 > 0 && (
                      <p className="text-center p-0 m-0" style={{ fontSize: "20px" }}>
                        Ready in {secondCount2}
                      </p>
                    )}
                  </div>
                )}

                <div
                  className="d-flex align-items-center justify-content-center gap-2 flex-grow-1 mb-4"
                  style={{ height: "40px" }}
                >
                  <MicWaveform
                    progressValue={recordCount * 12.5}
                    mockColor={"#0081A4"}
                    time={isRecording ? recordingTimeLeft : -1}
                  />
                </div>
              </div>

              <div className="audo-line"><span className="progress-bar-fill-Read intro"></span></div>
            </div>
          </div>}
          <Col xs={12}>
            {!props.resultMode && props.data && soundStatus && secondCount === 0 &&(
              isIOSDevice() ? (
              <IOSAudioPlayer
                audioUrl={questionAudio}
                onPlaying={handleSongPlaying}
                onLoading={loadingSound}
                onFinishedPlaying={handleSongFinishedPlaying}
                // onError={handleAudioError}
                volume={volume}
                playbackRate={playbackSpeed}
                soundKey={soundKey}
              />
              ) : (
              <Sound
                url={questionAudio}
                playStatus={Sound.status.PLAYING}
                onPlaying={handleSongPlaying}
                volume={volume}
                onLoading={loadingSound}
                onFinishedPlaying={handleSongFinishedPlaying}
                playbackRate={playbackSpeed}
                key={soundKey}
                soundManagerConfig={{ debugMode: false }}
              />)
              )}
          </Col>
          <Col xs={12}>
            {blobURL && !props.testMode && <audio src={blobURL} controls="controls" />}
          </Col>
        </div>
      </Col>
      <Col xs={12}><h5>{questionText}</h5></Col>
      {!isIOSDevice() && !props.resultMode && beepStatus && <Sound
        // url={s3base + "/ptedata/ptemedia/beep.mp3"}
        url={Beep}
        playStatus={Sound.status.PLAYING}
        onFinishedPlaying={handleBeepFinishedPlaying}
        onError={handleBeepFinishedPlaying}
      />}
    </>
  );
};

export default RepeatSentence;